<template>
  <index-view-layout
    data-name="user"
    :side-drawer-component="sideDrawerComponent"
    @search="searchUsers"
    searchable
  >
    <div class="w-full">
      <stacked-tabs
        :tabs="tabs"
        :selected-tab="selectedTab"
        @tab-selected="selectedTab = $event"
      />

      <template v-if="$mq === 'sm'">
        {{ /* TODO: Users cells for mobile?! */ }}
      </template>
      <bdg-table-view
        :rows="selectedItems"
        :columns="columns"
        :page-options="{ isPaged: selectedItems.length > 10, itemsPerPage: 10 }"
        :empty-state-text="emptyStateText"
        :loading="isLoading"
      />
    </div>
  </index-view-layout>
</template>

<script>
import IndexViewLayout from "./layouts/IndexViewLayout";
import StackedTabs from "../elements/StackedTabs";
import BdgTableView from "../elements/table-view/BdgTableView";
import UserForm from "../forms/UserForm";
import GenericDeleteModal from "../components/modals/GenericDeleteModal";
import { UserTypeLabels, UserTypes } from "../constants/user-enums";
import EmailCell from "../elements/table-view/special-cells/EmailCell";

function getIndividualUserActions(scope) {
  return [
    {
      label: "edit",
      clickAction: user => {
        scope.$store.commit("setCreateEditComponentParams", {
          createEditComponent: UserForm,
          createEditComponentData: user,
          createEditComponentIsShown: true
        });
      }
    },
    {
      label: "delete",
      clickAction: user => {
        scope.$store.commit("setConfirmationModalParams", {
          type: "delete",
          headerText: "Delete Confirmation",
          bodyComponent: GenericDeleteModal,
          bodyComponentData: {
            entityName: "user",
            deleteFunction: () => scope.$store.dispatch("deleteUser", user)
          },
          isShown: true
        });
      }
    }
  ];
}

export default {
  name: "Users",
  components: { BdgTableView, StackedTabs, IndexViewLayout },
  data() {
    return {
      sideDrawerComponent: UserForm,
      selectedTab: null,
      columns: [
        { label: "Name", property: "name" },
        { label: "Type", property: "typeLabel" },
        { label: "Email", property: "nestedEmail", cellComponent: EmailCell },
        {
          label: "Actions",
          property: "actions",
          actions: getIndividualUserActions(this),
          additionalCellClasses: "w-px whitespace-no-wrap"
        }
      ]
    };
  },
  computed: {
    tabs() {
      return this.$store.state.Users.indexTabs;
    },
    showSearchResults() {
      return this.$store.state.Search.areSearchResultsShown;
    },
    isGettingUsers() {
      return this.$store.state.Users.isGettingUsers;
    },
    isSearchingUsers() {
      return this.$store.state.Search.isSearchingUsers;
    },
    isLoading() {
      return this.showSearchResults
        ? this.isSearchingUsers
        : this.isGettingUsers;
    },
    users() {
      return this.$store.state.Users.users;
    },
    searchedUsers() {
      return this.$store.state.Search.searchedUsers;
    },
    displayedUsers() {
      let users = this.showSearchResults ? this.searchedUsers : this.users;
      if (users) {
        users = users.map(user => {
          user.typeLabel = UserTypeLabels[user.type];
          user.nestedEmail = { email: user.email };
          return user;
        });

        users.sort((a, b) => a.last_name.localeCompare(b.last_name));
      }
      return users;
    },
    selectedItems() {
      if (this.selectedTab && this.displayedUsers) {
        return this.displayedUsers.filter(user => {
          if (this.selectedTab.slug !== "all") {
            if (this.selectedTab.slug === "crew") {
              return (
                user.type === UserTypes.CREW_SUPERVISOR ||
                user.type === UserTypes.CREW_LEADER
              );
            }
            return user.type === this.selectedTab.slug;
          }
          return true;
        });
      }
      return [];
    },
    emptyStateText() {
      if (this.selectedTab) {
        switch (this.selectedTab.slug) {
          case "admin":
            return "No admin users to view.";
          case "designer":
            return "No designer users to view.";
          case "crew_leader":
            return "No crew leaders to view.";
          default:
            return "No users to view.";
        }
      }
      return "No users to view.";
    }
  },
  created() {
    this.$store.dispatch("getUsers");
  },
  methods: {
    searchUsers(text) {
      if (text && text.length) {
        this.$store.dispatch("searchUsers", text);
      } else {
        this.$store.commit("setAreSearchResultsShown", false);
      }
    }
  }
};
</script>

<style scoped></style>
